import {
  id,
  Id,
  Identifiable,
  list,
  Planzone,
  project,
  ProjectPortfolio,
  projectStatus,
  zone,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedProject, Linker } from "../linkers/types";

type PersistedPortfolio = Identifiable<Omit<ProjectPortfolio, "projects">> & {
  projects: Id[];
};

function extractProjectPortfolios(
  planzone: Identifiable<Planzone>,
): PersistedPortfolio[] {
  return planzone.data && !!planzone.data.projectPortfolios
    ? JSON.parse(planzone.data.projectPortfolios)
    : [];
}

function removeDuplicates<T>(arr: T[]): T[] {
  return [...new Set(arr)];
}

function getProjectPortfolios(httpClient: HttpClient, linker: Linker) {
  return ({ uuid }: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        method: HttpMethods.GET,
        endpoint: `/planzones/${uuid}`,
      })
      .then((planzone) => {
        const portfolios = extractProjectPortfolios(planzone);

        return portfolios.map((portfolio) => ({
          ...portfolio,
          projects: removeDuplicates(portfolio.projects).map((projectUuid) => ({
            ...project,
            uuid: projectUuid,
          })),
        }));
      });
}

export { getProjectPortfolios };
